import React from 'react';
import type { ColumnsType } from 'antd/es/table';
import { useGetBuyerVehiclesQuery } from '../../../app/api/vehicleApiSlice';
import Vehicle from '../../../core/models/Vehicle';
import { Table } from 'antd';
import { convertToCurrencyString } from '../../../utils/currencyUtil';
import { useNavigate } from 'react-router-dom';

interface IProps {
  buyerId: string;
}

const columns: ColumnsType<Vehicle> = [
    {
        title: 'VID',
        dataIndex: 'code',
        key: 'code',
    },
    {
        title: 'Registration No.',
        dataIndex: 'plateNumber',
        key: 'plateNumber',
    },
    {
        title: 'Make',
        dataIndex: 'make_Text',
        key: 'make',
        responsive: ['md'],
    },
    {
        title: 'Model',
        dataIndex: 'model_Text',
        key: 'model',
        responsive: ['md'],
    },
    {
        title: 'YoM',
        dataIndex: 'yom',
        key: 'yom',
        responsive: ['md'],
    },
    {
        title: 'Price',
        dataIndex: ['purchase', 'soldPrice'],
        key: 'price',
        render: (amount: number) => convertToCurrencyString(amount),
        responsive: ['md'],
    },
];

const ViewBuyerVehicles: React.FC<IProps> = ({ buyerId }: IProps) => {
    const navigate = useNavigate();
    const { data: buyerVehicles, isLoading } = useGetBuyerVehiclesQuery(buyerId);

    return <Table
    dataSource={buyerVehicles}
    columns={columns}
    rowKey='id'
    loading={isLoading}
    size='small'
    onRow={(record, rowIndex) => {
      return {
        onClick: (event) => {
          navigate(`/vehicles/${record.id}`);
        },
      };
    }}
  />;
};

export default ViewBuyerVehicles;
